export class User {
	id!: number;
	user!: string;
	personal!: string;
	estado!: number;

}